<div class="wrap" id="wrap">

  <div class="background_search_bar">
    <div class="search_bar">
      <form [formGroup]="searchForm">
        <input type="text" placeholder="Chercher un article ..." (input)="applyFilter($event.target.value)"
          formControlName="keyword">
        <fa-icon [icon]=" faTimes" (click)="resetSearch(); scrollToElement()" *ngIf="valueInput"></fa-icon>
      </form>
      <fa-icon [icon]=" faSearch"></fa-icon>
    </div>
  </div>

  <div *ngIf="!(itemsFluxFilter?.length === 0 && valueInput) && itemsFlux.length" class="flux_actu">
    <div #target id="target"></div>

    <ng-container *ngFor="let a of itemsFluxFilter && itemsFluxFilter.length? itemsFluxFilter : itemsFlux">
      <app-item-flux-rss [item]="a"></app-item-flux-rss>
    </ng-container>

    <div class="end_flux" (click)="scrollToElement()" *ngIf="itemsFlux.length">
      <fa-icon [icon]="faChevronUp"></fa-icon>
      <p>Il n'y a plus d'articles</p>
    </div>
  </div>
  <div class="message_search">
    <p *ngIf="itemsFluxFilter?.length === 0 && valueInput">Il n'y a pas de résultats</p>
  </div>

  <app-skeleton-flux *ngIf="!itemsFlux.length"></app-skeleton-flux>


  <!-- <a id="up" (click)="scrollToElement(target)">
      <fa-icon [icon]="faArrowUp"></fa-icon>
    </a> -->

</div>